import { render } from "./full-video-youtube.vue?vue&type=template&id=1cbbed3d&scoped=true"
import script from "./full-video-youtube.vue?vue&type=script&lang=js"
export * from "./full-video-youtube.vue?vue&type=script&lang=js"

import "./full-video-youtube.vue?vue&type=style&index=0&id=1cbbed3d&lang=css"
import "./full-video-youtube.vue?vue&type=style&index=1&id=1cbbed3d&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbbed3d"]])

export default __exports__